const getLocalizedString = (localizedStrings, locale)=>{
    var ref;
    let value = (ref = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale === locale
    )) === null || ref === void 0 ? void 0 : ref.value;
    // Business rule, localized version unavailable, try 'en' fallback
    if (value === undefined) {
        var ref1;
        value = (ref1 = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale.substr(0, 2) === 'en'
        )) === null || ref1 === void 0 ? void 0 : ref1.value;
    }
    return value || '';
};
const getLocalizedStrings = (localizedStrings, locale)=>{
    var ref;
    let values = (ref = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale === locale
    )) === null || ref === void 0 ? void 0 : ref.values;
    // Business rule, localized version unavailable, try 'en' fallback
    if (values === undefined) {
        var ref2;
        values = (ref2 = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale.substr(0, 2) === 'en'
        )) === null || ref2 === void 0 ? void 0 : ref2.values;
    }
    return values || [];
};

export { getLocalizedString, getLocalizedStrings };
//# sourceMappingURL=get-localized-string.js.map
